import axios from 'axios';

import { rootUrl } from '../../config/constants';

export const getNews = payload => {
  const url = `${rootUrl}/data/news/${payload.subject}.json`;
  return axios.get(url);
};
